import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

import PublicExchangeForm from '@kano/components/PublicExchangeForm.vue';
import { i18n, initPublicMessages } from '@kano/i18n';
import { initialDataParser } from '@/utilities/initialData';
import assetStore from '@/store/assets';
import { TokenService } from '@paybis/frontend-common-lib/src/publicApi';
import axios from 'axios';
import { initAPI } from '@paybis/frontend-common-lib/src/services/api';

async function init(props: object, lang: string, basePath: string) {
    if (!document) {
        return;
    }
    initAPI(axios, assetStore);

    let headingStyles: string = '';
    const heading = document.getElementById('form-heading');

    if (heading !== null) {
        headingStyles = heading.getAttribute('style') ?? '';
    }

    const routes: RouteConfig[] = [
        {
            path: '/:siteVariant?/:buyLink?/',
            name: 'Home',
            component: PublicExchangeForm,
            pathToRegexpOptions: {
                strict: true,
            },
            props: {
                ...props,
                lang,
                headingStyles,
            },
        },
    ];

    const defaultLocale = 'en';
    const { defaultBuyLink } = props;

    const router = new VueRouter({
        base: `${ basePath }/${ lang !== defaultLocale ? lang : '' }`,
        mode: 'history',
        routes,
    });

    router.beforeEach((to, from, next) => {
        if (to.params.buyLink === defaultBuyLink) {
            // XXX: we don't want to add `buy-bitcoin-with-credit-card` in the URL
            next({
                path: '/',
            });
        } else {
            next();
        }
    });

    // Warm assets in the background on purpose — the form renders without them, and
    // assets/init is single-flight guarded so later consumers await the same request.
    // (Do not move into the awaited Promise.all: that would delay mount by the fetch.)
    assetStore.dispatch('assets/init').catch(() => {});

    await Promise.all([
        initPublicMessages(),
        TokenService.hasToken() ? assetStore.dispatch('feature/init').catch(() => {}) : null,
    ]);

    Vue.config.silent = process.env.NODE_ENV === 'production';

    Vue.use(VueRouter);

    new Vue({
        router,
        i18n,
        render: h => h('router-view'),
    }).$mount('#exchange-form-app');
}

const { lang, props, basePath = '' } = initialDataParser(
    'exchangeForm',
    ['lang', 'props', 'basePath'],
);

init({ ...props }, lang, basePath);
